import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { changePassword, setPasswordChangeState, setPasswordChangeMessage } from "../../actions/userActions";
import { requestState } from "../../actions/utils";
import { Typography, Button, CircularProgress } from "@material-ui/core";
import { reduxForm, Field, submit, reset } from "redux-form";
import { renderTextField } from "../ReduxFormAdapters";
import "./PasswordChange.css";
import WideButton from "../Helpers/WideButton";

const formName = "passwordChange";

let PasswordChangeForm = ( props ) => {
    const { handleSubmit } = props;
    return (
        <form onSubmit={handleSubmit}>
            <Field
                name="old"
                component={renderTextField}
                label="Old password"
                type="password"
            />
            <Field
                name="new"
                component={renderTextField}
                label="New password, minimum 8 characters"
                type="password"
            />
            <Field
                name="confirmNew"
                component={renderTextField}
                label="Confirm new password"
                type="password"
            />
        </form>
    )
}

PasswordChangeForm = reduxForm({
    form: formName
})( PasswordChangeForm );

class PasswordChange extends Component {

    constructor( props ) {
        super( props );
        this.handleChange = this.handleChange.bind( this );
        this.handlePreSubmit = this.handlePreSubmit.bind( this );
        this.handleSubmit = this.handleSubmit.bind( this );
    }

    state = {
        hidden: true,
        error: "",
        pristine: true
    }

    componentDidMount() {
        this.props.clearMessages();
    }

    handleChange( values, dispatch, props, previousValues ) {
        if ( this.state.pristine )
            this.setState({ pristine: false });
        const error = !this.validate( values );
        if ( error !== this.state.error )
            this.setState({ error: error });
    }

    handlePreSubmit() {
        this.props.manualSubmit( formName );
    }

    handleSubmit( values, dispatch, props ) {
        this.props.changePassword( values.old, values.new );
    }

    validate( values ) {
        return ( values.old && values.new && values.confirmNew ) && ( values.new === values.confirmNew ) && values.confirmNew.length >= 8;
    }

    render() {
        const { state, message } = this.props;
        const disableSubmit = this.state.pristine || this.state.error;
        return (
            <div className="PasswordChange">
                <WideButton
                    variant="outlined"
                    color={this.state.hidden ? "secondary" : "primary"}
                    onClick={() => this.setState({ hidden: !this.state.hidden })}
                >
                    Change Password
                </WideButton>
                {
                    !this.state.hidden &&
                    <Fragment>
                        <PasswordChangeForm onChange={this.handleChange} onSubmit={this.handleSubmit}/>
                        <div className="PasswordChange-submit-container">
                            <Button
                                variant="contained"
                                size="large"
                                color="primary"
                                disabled={disableSubmit}
                                onClick={this.handlePreSubmit}
                            >
                                Submit
                            </Button>
                            {
                                state === requestState.inProgress &&
                                <CircularProgress/>
                            }
                        </div>
                        <Typography
                            color={state === requestState.fail ? "error" : "secondary"}
                        >
                            {message}
                        </Typography>
                    </Fragment>
                }
            </div>
        )
    }

}

export default connect(
    state => ({
        state: state.user.passwordChangeState,
        message: state.user.passwordChangeMessage
    }),
    dispatch => ({
        changePassword: ( oldPassword, newPassword ) => dispatch( changePassword( oldPassword, newPassword ) ),
        clearMessages: () => {
            dispatch( setPasswordChangeState( requestState.none ) );
            dispatch( setPasswordChangeMessage( "" ) );
            dispatch( reset( formName ) )
        },
        manualSubmit: ( form ) => dispatch( submit( form ) )
    })
)( PasswordChange )